const DEFAULT_LOCALE = {
  thumb1: 'Lower thumb',
  thumb2: 'Upper thumb',
};

export { DEFAULT_LOCALE };
